import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Loader2, CreditCard } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const statusBadge = (status) => {
  const map = {
    paid: 'bg-green-500/20 text-green-400 border-green-500/30',
    pending: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    failed: 'bg-red-500/20 text-red-400 border-red-500/30'
  };
  const cls = map[status] || 'bg-[#2A2A2A] text-[#A19D98] border-[#2A2A2A]';
  return (
    <span className={`px-2 py-0.5 text-xs font-['Oswald'] tracking-wider border ${cls}`}>
      {(status || 'unknown').toUpperCase()}
    </span>
  );
};

const AccountPayments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/account/payments`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="account-payments">
      <h2 className="font-['Oswald'] text-2xl text-[#F2EDE6] tracking-wider mb-6">PAYMENT HISTORY</h2>
      {loading ? (
        <div className="text-center py-12">
          <Loader2 className="w-8 h-8 text-[#E8651A] animate-spin mx-auto" />
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-[#2A2A2A]">
          <CreditCard className="w-12 h-12 text-[#2A2A2A] mx-auto mb-3" />
          <p className="text-[#A19D98]">No payments yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div
              key={p.session_id}
              data-testid={`payment-${p.session_id}`}
              className="bg-[#0A0A0A] border border-[#2A2A2A] p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
            >
              <div>
                <h3 className="font-['Oswald'] text-[#F2EDE6] tracking-wider">
                  {p.rally_name || 'Rally Payment'}
                </h3>
                <p className="text-[#A19D98] text-xs mt-1">
                  {new Date(p.created_at).toLocaleString()}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-['Oswald'] text-[#F2EDE6] text-lg">
                  ${p.amount?.toFixed(2)} {p.currency?.toUpperCase()}
                </span>
                {statusBadge(p.payment_status)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountPayments;
